import { formatPrice } from '@/common/constant';
import type { WineProductItem } from '@/common/domain-model/product-search';
import { capitalize } from '@/common/utils';
import { useCurrencySymbol } from '@/hooks/useCurrencySymbol';
import { Tag } from 'antd';
import type { FC } from 'react';
import RatingIcon from '../../_/rating.svg?react';

export const HeaderView: FC<{ productItem: WineProductItem }> = ({
  productItem,
}) => {
  const { currency } = useCurrencySymbol();

  return (
    <div className="flex justify-between">
      <div className="flex flex-col gap-2 flex-1">
        <h1 className="text-xl font-bold w-2/3">{productItem.data.title}</h1>
        <div className="flex items-center gap-2">
          {productItem.data.wine_type ? (
            productItem.data.wine_type === 'other' ? (
              <Tag color="purple">
                Other ({productItem.data.wine_type_other})
              </Tag>
            ) : (
              <Tag color="purple">{capitalize(productItem.data.wine_type)}</Tag>
            )
          ) : null}
          <span className="text-gray">
            {productItem.data.country
              ? productItem.data.country === 'Other'
                ? `Other (${productItem.data.country_other})`
                : productItem.data.country
              : null}
          </span>
        </div>
      </div>
      <div className="flex gap-4 mr-8">
        <div className="flex flex-col gap-2">
          <span>Price</span>
          <span className="text-2xl font-bold">
            {formatPrice(productItem.data.price, currency)}
          </span>
        </div>
        <div className="flex flex-col gap-2">
          <span>Rating</span>
          <div>
            {productItem.data.rating ? (
              <div className="flex items-center gap-1">
                <RatingIcon
                  className="text-yellow-500 w-4 h-4"
                  fill="currentColor"
                />
                <span className="text-2xl font-bold">
                  {productItem.data.rating}
                </span>
              </div>
            ) : (
              <span className="text-gray">-</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
